import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <img
              src="/assets/otp-logo.png"
              alt="OTP Sports"
              className="footer-logo-img"
            />
          </div>

          <div className="footer-social">
            <a
              href="https://www.instagram.com/teamotpsports"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="Instagram"
            >
              <svg width="22" height="22" fill="white" viewBox="0 0 24 24">
                <path d="M7 2C4.2 2 2 4.2 2 7v10c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V7c0-2.8-2.2-5-5-5H7zm5 5.2a4.8 4.8 0 110 9.6 4.8 4.8 0 010-9.6zm6.2-.9a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4zM12 9a3 3 0 100 6 3 3 0 000-6z" />
              </svg>
            </a>

            <a
              href="https://www.linkedin.com/company/teamotpsports"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="LinkedIn"
            >
              <svg width="22" height="22" fill="white" viewBox="0 0 24 24">
                <path d="M4.98 3.5C4.98 4.88 3.87 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1c1.37 0 2.48 1.12 2.48 2.5zM.5 8.98h4V24h-4V8.98zm7.49 0h3.84v2.05h.05c.53-1 1.82-2.05 3.75-2.05 4 0 4.74 2.63 4.74 6.05V24h-4v-6.98c0-1.67-.03-3.82-2.33-3.82-2.34 0-2.7 1.82-2.7 3.7V24h-4V8.98z" />
              </svg>
            </a>

            <a
              href="https://x.com/teamotpsports"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="Twitter / X"
            >
              <svg width="22" height="22" fill="white" viewBox="0 0 24 24">
                <path d="M18.9 2L9.8 12.9l7.8 9.1h-2.8l-6.8-8-2.4 2.6v5.4H2V2h3.6v8.1L14.1 2h4.8z" />
              </svg>
            </a>

            <a
              href="https://www.youtube.com/@TeamOTPSports"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="YouTube"
            >
              <svg width="26" height="26" fill="white" viewBox="0 0 24 24">
                <path d="M23.5 6.2a3 3 0 00-2.1-2.1C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.4.6A3 3 0 00.5 6.2C0 8.1 0 12 0 12s0 3.9.5 5.8a3 3 0 002.1 2.1c1.9.6 9.4.6 9.4.6s7.5 0 9.4-.6a3 3 0 002.1-2.1c.5-1.9.5-5.8.5-5.8s0-3.9-.5-5.8zM9.7 15.4V8.6l6.3 3.4-6.3 3.4z" />
              </svg>
            </a>
          </div>

          <div className="footer-text">
            <p>© {currentYear} OTP Sports. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
